import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_membership_attachment_RowClass } from '../../../dbschema';

export class MembershipAttachmentContainerModel extends BaseContainerModel {
    bl_crm_membership_attachment: bl_crm_membership_attachment_RowClass = new bl_crm_membership_attachment_RowClass();
}
